import { FunctionComponent } from "react";
import { Button } from "../generic";
import { userTypes } from "src/utils/types";
import { sendgrid } from "src/utils";
import { ToastStatus, useToast } from "src/context/ToastContext";

interface IRequestFollowupProps {
    client: userTypes.Client
}

const RequestFollowup: FunctionComponent<IRequestFollowupProps> = ({ client }) => {
    const { setToast } = useToast();

    const requestClientFollowup = async () => { 
        try {
            const result = await sendgrid.sendFollowupRequest(
                client.userInfo.name,
                client.userInfo.email,
                client.metadata.stripeId
            );

            if (result.status === 202) {
                setToast({
                    message: "Follow-Up Email Sent",
                    status: ToastStatus.SUCCESS
                });
            }
        } catch (error: any) {
            setToast({
                message: error?.message || "Email Failed to Send",
                status: ToastStatus.FAIL
            });
        }
    };

    return (
        <Button
            text="Request Followup Appointment"
            onClick={requestClientFollowup}
            styles="w-[300px]"
        />
    );
}

export default RequestFollowup;